import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { ArrowLeft } from "lucide-react";
import { useSearchParams } from "react-router-dom";

import AssetRequest from "./AssetRequest";
import AccessRequest from "./AccessRequest";
import PageShell from "../../v2/components/shared/page-shell/page-shell.tsx";
import { Card } from "../../v2/components/shared/card/card.tsx";
import { useBreadcrumbs } from "../../v2/context/breadcrumb/breadcrumb-context.tsx";
import {
  ButtonLink,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../v2/components/ui/index.ts";

import styles from "./it-requests-tabs.module.css";

const TAB_VALUES = ["asset", "access"];

export const AssetRequestTabs = ({ title }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [searchParams] = useSearchParams();
  const { setBreadcrumbs } = useBreadcrumbs();
  const tabs = [
    { label: "Asset Request", component: AssetRequest },
    { label: "Access Request", component: AccessRequest },
  ];

  console.log("title: ", title);

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam === "access") {
      setActiveTabIndex(1); // Open Access Request tab
    } else if (tabParam === "asset") {
      setActiveTabIndex(0); // Open Asset Request tab
    }
  }, [searchParams]);

  const activeTabValue = TAB_VALUES[activeTabIndex] ?? TAB_VALUES[0];
  const activeTabLabel = tabs[activeTabIndex]?.label ?? tabs[0].label;

  useEffect(() => {
    setBreadcrumbs([
      { label: "IT Requests", path: "/dashboard/assetRequest" },
      { label: activeTabLabel },
    ]);
    return () => setBreadcrumbs([]);
  }, [activeTabLabel, setBreadcrumbs]);

  return (
    <PageShell>
      <header className={styles.pageHeader}>

      </header>

      <Card className={styles.tableCard} padding="5xl">
        <Tabs
          value={activeTabValue}
          onValueChange={(value) => {
            const nextIndex = TAB_VALUES.indexOf(value);
            setActiveTabIndex(nextIndex === -1 ? 0 : nextIndex);
          }}
        >
          <div className={styles.tabBar}>
            <TabsList className={clsx(styles.tabsList)}>
              {tabs.map((item, index) => (
                <TabsTrigger
                  key={item.label}
                  value={TAB_VALUES[index]}
                  className={styles.tabTrigger}
                >
                  {item.label}
                </TabsTrigger>
              ))}
            </TabsList>
            <ButtonLink
              to={`/dashboard/assetRequest?tab=${activeTabValue}`}
              variant="muted-outline"
              startIcon={<ArrowLeft size={16} strokeWidth={2} aria-hidden />}
            >
              Back
            </ButtonLink>
          </div>

          {tabs.map((item, index) => {
            const Component = item.component;
            const value = TAB_VALUES[index];
            return (
              <TabsContent
                key={item.label}
                value={value}
                className={styles.tabPanel}
              >
                {activeTabIndex === index && (
                  <Component title={item.label} description={""} />
                )}
              </TabsContent>
            );
          })}
        </Tabs>
      </Card>
    </PageShell>
  );
};

export default AssetRequestTabs;
